export default "__VITE_ASSET__DSxpeJ4P__"